var map = {
	"./gesellschaft-FG.png": 965,
	"./international-FG.png": 260,
	"./kultur-FG.png": 269,
	"./lifestyle-FG.png": 267,
	"./politik-FG.png": 366,
	"./sport-FG.png": 386,
	"./wirtschaft-FG.png": 47
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 375;